import { BrowserSearchEngine } from './common'

const defaultFieldSpecifiers = [
  { name: 'altloc' },
  { name: 'contains' },
  { name: 'domain' },
  { name: 'ext' },
  { name: 'feed' },
  { name: 'filetype' },
  { name: 'hasfeed' },
  { name: 'imagesize' },
  { name: 'inanchor' },
  { name: 'inbody' },
  { name: 'instreamset' },
  { name: 'instreamset:url' },
  { name: 'intitle' },
  { name: 'ip' },
  { name: 'language' },
  { name: 'literalmeta' },
  { name: 'loc' },
  { name: 'location' },
  { name: 'meta' },
  { name: 'msite' },
  { name: 'near' },
  { name: 'site' },
  { name: 'url' }
]

const defaultSyntaxGuideUrl = 'https://help.bing.microsoft.com/#apex/18/en/10002/-1'

class BingEngine extends BrowserSearchEngine {
  constructor (fieldSpecifiers) {
    super('Bing')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }
  formulateQuery (query) {
    return 'https://www.bing.com/search?q=' + query
  }
  lintQuery (queryGraphData) {
    const r = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    return r ? [r] : []
  }
}

export default BingEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/BingEngine.js